import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class NdsService extends BaseService {
  protected baseUrl = '/basis/catalog/nds';
}
